import React from 'react';
import PropTypes from 'prop-types';
import {FieldTable} from '../../../components/FieldTable/FieldTable';
import {asMoney} from '../../../utils';
import {FieldTableColumnProps} from 'components/FieldTable/FieldTableTypes';
import {SiteBuildType} from 'generated/graphql';
import {SiteBuildTypeSelect} from "../../../components/MaterialSelects/SiteBuildTypeSelect";
import {SiteBuildContractorSelect} from "../../../components/MaterialSelects/SiteBuildContractorSelect";
import {IsoDatePicker} from "../../../components/IsoDatePicker";
import {Card, CardContent, TextField} from "@mui/material";
import {NumberField} from "../../../components/number-input";
import {FixedField} from "../../../components/FixedField";
import {CurrencyField} from "../../../components/CurrencyInput";

const columns: FieldTableColumnProps<SiteBuildType>[] = [
    {
        accessor: 'expand',
        dataType: 'expander'
    },
    {
        header: 'Type',
        accessor: 'buildType',
        sort: 'buildType.label',
        dataType: 'select',
        options: {
            label: 'label',
            renderEditor: ({field}) =>
                <SiteBuildTypeSelect {...field} />
        }
    }, {
        header: 'PO No',
        accessor: 'po_number',
        dataType: 'text',
        width: 'narrow',
    }, {
        header: 'Panels',
        accessor: 'panel',
        width: 'narrow',
        dataType: 'text'
    }, {
        header: 'Contractor',
        accessor: 'buildContractor',
        sort: 'buildContractor.label',
        dataType: 'select',
        options: {
            label: 'label',
            renderEditor: ({field}) => <SiteBuildContractorSelect {...field} />
        }
    }, {
        header: 'Invoice',
        accessor: 'invoice_number',
        width: 'narrow',
        dataType: 'text'
    }
];

function newRow() {
    return ({
        buildType: null,
        buildContractor: null,
        panel: '',
        invoice_number: ''
    });
}

const BuildDetail = ({name, values, onChange, loading, readOnly}) => {
    const field = {
        onChange: onChange,
        loading: loading,
        readOnly: readOnly
    };
    const total_costs = asMoney(values.costs_1 + values.costs_2 + values.costs_3 + values.costs_4 + values.costs_5);
    return <Card className="site-build__detail">
        <CardContent className="grid12">
        <IsoDatePicker className="grid12-4" {...field} name={name + '.completion_date'} value={values.completion_date} label="Date"/>
        <div className="grid12">
            {['1', '2', '3', '4', '5'].map((idx) => (
                <>
                    <TextField className="grid12-8 site-build__cost-comment"
                               name={name + '.costs_comments_' + idx}  {...field}
                               value={values['costs_comments_' + idx]} label="Item"/>
                    <CurrencyField value={values['costs_' + idx]} {...field} name={name + '.costs_' + idx}
                                   className="grid12-4"/>
                </>
            ))}
        </div>
        <FixedField label="Total Cost" value={total_costs}/>
        <NumberField name={name + '.quantity'}  {...field} value={values.quantity} label="Quantity"/>
        <TextField {...field} name={name + '.issued_by'} value={values.issued_by} label="Issued By"/>
        <TextField fullWidth={true} multiline={true} {...field} name={name + '.additional_info'}
                   value={values.additional_info} label="Additional Info"/>
        <IsoDatePicker className="grid12-4" {...field} name={name + '.completion_deadline'} value={values.completion_deadline}
                       label="Completion Deadline"/>
        </CardContent>
    </Card>;
};


const BuildAndMaintenancePane = ({values, setValue, onChange, loading, readOnly}) => {
    return (
        <FieldTable columns={columns}
                    name="siteBuildAndRepairs"
                    values={values}
                    setValue={setValue}
                    newRow={newRow}
                    className="site-build-and-repairs"
                    newRowLabel="Add new site build/repair item"
                    readOnly={readOnly}
        >{
            ({name, row}) => {
                return <BuildDetail name={name} onChange={onChange} values={row} loading={loading}
                                    readOnly={readOnly}/>;
            }
        }</FieldTable>
    );
}

BuildAndMaintenancePane.propTypes = {
    health_and_safety: PropTypes.array
};

export default BuildAndMaintenancePane;

